import React from 'react';
import Navbar from './Component/Navbar';
import Footer from './Component/Footer';

 const Contact = () => {
  return (
    <>
    <Navbar/>
    {/*Section: Contact v.1*/}
<section className="contact-section pb-5">
  {/*Section heading*/}
  <h2 className="section-heading h1 pt-4">Contact us</h2>
  {/*Section description*/}
  <p className="section-description pb-4">Supreme Biosolution is pioneer in manufacturing of specialty heath care products in the field of aquaculture with the self commitment to provide the best quality to the customers.</p>
  <div className="row">
    {/*Grid column*/}
    <div className="col-lg-5 mb-4">
      {/*Form with header*/}
      <div className="card">
        <div className="card-body">
          {/*Header*/}
          <div className="form-header blue accent-1">
            <h3><i className="fa fa-envelope" /> Write to us:</h3>
          </div>
          
          <br />
          {/*Body*/}
          <div className="md-form">
            <i className="fa fa-user prefix grey-text" />
            <input type="text" id="form-name" className="form-control" />
            <label htmlFor="form-name">Your name</label>
          </div>
          <div className="md-form">
            <i className="fa fa-envelope prefix grey-text" />
            <input type="text" id="form-email" className="form-control" />
            <label htmlFor="form-email">Your email</label>
          </div>
          <div className="md-form">
            <i className="fa fa-tag prefix grey-text" />
            <input type="text" id="form-Subject" className="form-control" />
            <label htmlFor="form-Subject">Subject</label>
          </div>
          <div className="md-form">
            <i className="fa fa-pencil-alt prefix grey-text" />
            <textarea id="form-text" className="form-control md-textarea" rows={3} defaultValue={""} />
            <label htmlFor="form-text">Message</label>
          </div>
          <div className="contact-btn text-center mt-4">
            <button className="btn btn-light-blue">Submit</button>
          </div>
        </div>
      </div>
      {/*Form with header*/}
    </div>
    {/*Grid column*/}
    {/*Grid column*/}
    <div className="col-lg-7">
      {/*Google map*/}
      <div id="map-container-google-11" className="z-depth-1-half map-container-6" style={{"height":"400px"}}>
        {/* <iframe src="https://maps.google.com/maps?q=new%20delphi&t=&z=13&ie=UTF8&iwloc=&output=embed" frameBorder={0} style={{"border":"0"}} allowFullScreen /> */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121499.82608883032!2d83.3402555879535!3d17.891551601141508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a395832900b6741%3A0xe68cf51cb60250bb!2sAndhra%20Pradesh%20531163!5e0!3m2!1sen!2sin!4v1622444609200!5m2!1sen!2sin" frameBorder={0} style={{"border":"0"}} allowFullScreen ></iframe>
      </div>
      <br />
      {/*Buttons*/}
      <div className="row text-center">
        <div className="col-md-4">
          <a className="btn-floating blue accent-1"><i className="fa fa-map-marker" /></a>
          <p className="address" >13-104/A, bheemunipatnam Mandalam,<br/> Vishakhapatnam, Andhrapradesh,<br/> PIN - 531163 </p>
          
        </div>
        <div className="col-md-4">
          <a className="btn-floating blue accent-1"><i className="fa fa-phone" /></a>
          <p>+ 01 234 567 89</p>
          <p>Mon - Fri, 8:00-22:00</p>
        </div>
        <div className="col-md-4">
          <a className="btn-floating blue accent-1"><i className="fa fa-envelope" /></a>
          <p>info@<br/>supremebiosolution.com</p>
          
        </div>
      </div>
    </div>
    {/*Grid column*/}
  </div>
</section>
{/*Section: Contact v.1*/}
<Footer/>
    </>
  )
}
export default Contact;